import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

const store = (set) => {
  return {
    topLiveList: {
      count: 0,
      list: [],
    },
    checkAd: {
      hasNewAd: false,
      banners: {},
      AdParameter: {},
    },
    banner: {
      main: {
        key: '', //location key 값
        type: '', //광고 형태 타입
        exist: false, //광고 존재 여부
        creatives: [],
      },
      sub: {
        key: '', //location key 값
        type: '', //광고 형태 타입
        exist: false, //광고 존재 여부
        category: '',
        creatives: [],
      },
    },
    isCloseMainBanner: false, //메인배너 닫힘
    isShowMainBanner: false, //메인배너 노출/비노출
    resizeCount: 1,
    resizeMainLiveCount: 1,
    resizeCategoryCount: 3,
    setTopLiveList: (item) => {
      set((state) => {
        return {topLiveList: {...state.topLiveList, ...item}};
      });
    },
    setIsShowMainBanner: (item) => {
      set((state) => {
        return {isShowMainBanner: item};
      });
    },
    setIsCloseMainBanner: (item) => {
      set((state) => {
        return {isCloseMainBanner: item};
      });
    },

    setCheckAd: (item) => {
      set((state) => {
        return {checkAd: {...state.checkAd, ...item}};
      });
    },
    // 241115 : 긴급수정 - 홈으로 되돌아 왔을때 트래킹URL이 갱신되지 않아 예전 트래킹 URL을 계속 호출하는 문제를 후루꾸로 처리함. 배너 광고 쪽 정리가 필요함. 함정카드가 많다.
    resetBanner: () => {
      set((state) => {
        return {
          banner: {
            main: {
              key: '', //location key 값
              type: '', //광고 형태 타입
              exist: true, //광고 존재 여부 - MyPlus getBanner()에서 호출될되면서 reset을 호출하는데 이게 useBanner의 checkAd userEffect에서 exist 콘디션이랑 종종 겹쳐서 api 두번 호출되는 문제
              creatives: [],
            },
            sub: {
              key: '', //location key 값
              type: '', //광고 형태 타입
              exist: true, //광고 존재 여부 - MyPlus getBanner()에서 호출될되면서 reset을 호출하는데 이게 useBanner의 checkAd userEffect에서 exist 콘디션이랑 종종 겹쳐서 api 두번 호출되는 문제
              category: '',
              creatives: [],
            },
          },
        };
      });
    },
    setBanner: (item) => {
      set((state) => {
        return {banner: {...state.banner, ...item}};
      });
    },
    setResizeCount: (item) => {
      set((state) => {
        return {resizeCount: item};
      });
    },
    setResizeMainLiveCount: (item) => {
      set((state) => {
        return {resizeMainLiveCount: item};
      });
    },
    setResizeCategoryCount: (item) => {
      set((state) => {
        return {resizeCategoryCount: item};
      });
    },
  };
};

const useMainStore = create(devtools(store));
export default useMainStore;
